import { Card, CardHeader, CardContent, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { Edit } from "lucide-react";

interface StepCardProps {
  step: number;
  title: string;
  isActive: boolean;
  isCompleted: boolean;
  onEdit?: () => void;
  stepData?: any;
  StepSummary?: React.ComponentType<{ data: any }>;
  children: React.ReactNode;
}

export function StepCard({
  step,
  title,
  isActive,
  isCompleted,
  onEdit,
  stepData,
  StepSummary,
  children,
}: StepCardProps) {
  const cardClassName = cn("transition-all", {
    "bg-white/50": !isActive || isCompleted,
    "bg-white": isActive,
  });

  const stepNumberClassName = cn(
    "inline-flex items-center justify-center w-6 h-6 rounded-full mr-3 font-medium",
    {
      "bg-muted-foreground/40 text-white": !isActive && !isCompleted,
      "bg-primary text-white": isActive || isCompleted,
    }
  );

  // Only apply pb-0 if the step is neither active nor has a completed summary to show
  const cardContentClassName = cn({
    "pb-5": isActive || (isCompleted && StepSummary && stepData),
    "pb-0": !isActive && (!isCompleted || !StepSummary || !stepData),
  });

  return (
    <Card className={cardClassName}>
      <CardHeader className="flex flex-row items-center justify-between p-5">
        <div className="flex items-center">
          <span className={stepNumberClassName}>{step}</span>
          <CardTitle className="text-base font-heading">{title}</CardTitle>
        </div>
        {isCompleted && onEdit && (
          <button
            onClick={onEdit}
            className="text-gray-500 hover:text-gray-700"
          >
            <Edit className="w-4 h-4" />
          </button>
        )}
      </CardHeader>
      <CardContent className={cardContentClassName}>
        {isActive ? (
          children
        ) : isCompleted && StepSummary && stepData ? (
          <StepSummary data={stepData} />
        ) : null}
      </CardContent>
    </Card>
  );
}
